import { useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';
import { useAppSelector } from '@/app/hooks';
import { OVERVIEW_ZOOM_THRESHOLD } from '@/app/constants';
import { GoogleEvents } from '@/features/googleEvents';
import { LayerType } from '@/views/map/layers/types';

/**
 * Triggers when the spread potential layer becomes visible: zoomed into
 * the span polygon level and the spread potential map layer is on.
 * Triggers once each time that combination becomes true.
 */
export const useSpreadPotentialViewedAnalytics = () => {
  const zoom = useAppSelector((state) => state.analysisMap.viewState.zoom);
  const fuelHazardLayerOn = useAppSelector(
    (state) => state.mapLayer[LayerType.fuel_hazard].visible
  );
  const lastLayerVisible = useRef(false);

  useEffect(() => {
    const layerVisible = zoom >= OVERVIEW_ZOOM_THRESHOLD && fuelHazardLayerOn;
    if (layerVisible && !lastLayerVisible.current) {
      TagManager.dataLayer({
        dataLayer: { event: GoogleEvents.spreadPotentialViewed },
      });
    }
    lastLayerVisible.current = layerVisible;
  }, [zoom, fuelHazardLayerOn]);
};
